<template>
  <div :class="`top-bar-container top-bar-container-${theme}`">
    <wrap-container class="w100 padding-17-left-right">
      <div class="inner-container">
        <div class="logo" v-if="!config.pasos[ruta].header">
          <img :src="logo" alt="BBVA" />
        </div>
        <div :class="!config.pasos[ruta].header ? 'modulo' : 'custom-header'">
          <p
            v-safe-html="
              config.pasos[ruta].header
                ? config.pasos[ruta].header
                : config.modulo
            "
          />
        </div>
      </div>
    </wrap-container>
    <progress-bar />
  </div>
</template>

<script>
import Vue from "vue";
import WrapContainer from "@/components/core/Container";

Vue.component("progress-bar", () => import("./ProgressBar"));

export default {
  name: "TopBar",
  components: { WrapContainer },
  props: {
    theme: {
      type: String,
      default: "dark"
    }
  },
  computed: {
    ruta() {
      return this.$store.state.route.name;
    },
    logo() {
      return require(`@/assets/img/logo-${this.theme}-theme.svg`);
    }
  }
};
</script>

<style scoped>
div.top-bar-container {
  background: #072146;
  color: white;
  position: fixed;
  width: 100%;
  z-index: 9999;
}

div.top-bar-container-dark {
  background: #043263;
  color: white;
}

div.top-bar-container-light {
  background: white;
  color: #043263;
}

div.inner-container {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.logo img {
  height: 20px;
}

div.modulo {
  text-align: right;
}

div.modulo p {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

div.custom-header {
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

p {
  font-size: 16px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

@media screen and (max-width: 420px) {
  div.logo img {
    height: 13px;
  }
  p {
    font-size: 12px;
  }

  div.custom-header p {
    font-size: 15px;
    font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  }
}
</style>
